import request from '@/http/request'
import{  
    getSelectPlan,
    getPlanCourse,
    getSubCourseList,
    scoredRuleList,
    scoredRuleListExport,
    confirmScoredRuleByPlanId,
    resetScoredRuleByPlanId
} from '@/http/api'


export const getSelectPlanFn = (data) => {
  return request({
    url: getSelectPlan,
    data,
  })
}

export const getPlanCourseFn = (data) => {
  return request({
    url: getPlanCourse,
    data,
  })
}

export const getSubCourseListFn = (data) => {
  return request({
    url: getSubCourseList,
    data,
  })
}

export const scoredRuleListFn = (data) => {
  return request({
    url: scoredRuleList,
    data,
  })
}

export const scoredRuleListExportFn = (data) => {
  return request({
    url: scoredRuleListExport,
    data,
  })
}

export const confirmScoredRuleByPlanIdFn = (data) => {
  return request({
    url: confirmScoredRuleByPlanId,
    data,
  })
}

export const resetScoredRuleByPlanIdFn = (data) => {
  return request({
    url: resetScoredRuleByPlanId,
    data,
  })
}